<template>
  <pt-points-reward-table class="pt-points-reward-table__withData" :tableLabels="tableLabels" :pageSize="pageSize" :tableData="tableData" :isOutside="isOutside"
  @getTableData="getTableData" @select="select" ref="table" @selectAll="selectAll" :totalNumber="totalNumber"
  :isShowSelect="isShowSelect" v-loading="loading">
  <slot/>
  </pt-points-reward-table>
</template>

<script>
import PtPointsRewardTable from './index'
export default {
  name: 'pt-points-reward-table__withData',
  components: {
    'pt-points-reward-table': PtPointsRewardTable
  },
  props: {
    isShowSelect: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    // isOutside: {
    //   type: Boolean,
    //   default: false
    // },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      isOutside: false,
      loading: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val, old) {
        if (!this.isFromRouter) {
        //   this.getOrderList(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      let data = {
        pageable: {
          page: this.page,
          size: size || this.pageSize,
          sort: 'createdDate,desc'
        },
        ...this.paramsData
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getPointsRewardList', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取积分发放列表失败')
        this.loading = false
      })
    },
    select (row) {
      this.$emit('select', row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    }
  }
}
</script>
